import React, { Component } from 'react';
import { connect } from 'react-redux';
import { last, get, findLast } from 'lodash';
import { FormattedMessage } from 'react-intl';

import About from './about';
import Contributors from '../../components/purchase-dashboard/contributors/contributors';
import ShortContributors from '../../components/purchase-dashboard/contributors/contributors.short';
import FailedContributors from '../../components/purchase-dashboard/contributors/contributors.failed';
import HoldoutContributors from '../../components/purchase-dashboard/contributors/contributors.holdouts';
import InfoMessage from '../../components/purchase-dashboard/info-message';
import DetailsNavbar from '../../components/purchase-dashboard/details-navbar';
import PurchaseDetails from './purchase-details';
import PurchaseInfo from '../../components/purchase-dashboard/purchase-info';
import DashboardTermsAndConditions from '../../components/purchase-dashboard/terms-and-conditions';
import Title from '../../components/title';
import Purchase from '../../lib/purchase';
import Payment from '../../lib/payment';
import Membership from '../../lib/membership';
import { ALERT_MUST_LOG_IN_TO_INVITE } from '../../actions';
import Activities from '../../components/purchase-dashboard/activities';

import {
  getCurrentPurchase,
  getOrganizerMembership,
  getCurrentUserMembership,
  getFailedMemberships,
  getShortMemberships,
  getCommittedMemberships,
  getHoldoutMemberships,
  getMemberships,
} from '../../selectors/purchase-selector';
import {
  getCurrentUser,
} from '../../selectors/user-selector';
import {
  showAlert,
  showInviteModal,
  showRemoveModal,
  showResolveIssuesModal,
  postPurchaseComment,
  fetchPurchaseActivities,
} from '../../actions';

const jQuery = window.jQuery;

const PAYMENT_STATUS_PROCESSING = 'processing_payout';
const PAYMENT_STATUS_COMPLETED = 'completed';
const PAYMENT_STATUS_AUTHORIZING = 'authorizing';
const PAYMENT_STATUS_AUTHORIZED = 'authorized';

class DashboardBody extends Component {
  constructor(props) {
    super(props);
    this.onScrollTo = this.onScrollTo.bind(this);
    this.onCantInvitePeople = this.onCantInvitePeople.bind(this);
    this.onInvitePeople = this.onInvitePeople.bind(this);
    this.onSolveIssues = this.onSolveIssues.bind(this);
    this.onRemoveMember = this.onRemoveMember.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { purchase, memberships } = this.props;
    const { authentication } = nextProps;

    if (nextProps.memberships.length !== memberships.length) {
      this.props.fetchPurchaseActivities(purchase.id, nextProps.authentication);
    }

    if (authentication.token && !this.props.authentication.token) {
      this.props.fetchPurchaseActivities(purchase.id, nextProps.authentication);
    }
  }

  onScrollTo(sectionName) {
    const section = jQuery(`#${sectionName}`);
    if (!section.length) return;
    const top = section.offset().top - 70;
    try {
      window.scroll({
        behavior: 'smooth',
        top,
      });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  onInvitePeople() {
    this.props.showInviteModal();
  }

  onCantInvitePeople() {
    this.props.showAlert(ALERT_MUST_LOG_IN_TO_INVITE);
  }

  onSolveIssues() {
    this.props.showResolveIssuesModal();
  }

  onRemoveMember(membership) {
    this.props.showRemoveModal({ memberships: [membership] });
  }

  onPostComment = (text) => {
    const { purchase, authentication, currentUser } = this.props;

    const data = { userId: currentUser.id, text };
    return this.props.postPurchaseComment(purchase.id, authentication, data);
  }

  hasMembershipsIssues() {
    const { purchase } = this.props;
    return purchase.memberships.filter(m => m.failed || m.short).length > 0;
  }

  hasPaymentStatuses(statuses = []) {
    const { purchase } = this.props;
    return purchase.payments.filter(p => {
      return statuses.some(s => s === p.status);
    }).length > 0;
  }

  isAuthorizingPayment() {
    const { purchase } = this.props;
    const payment = purchase.currentPayment || last(purchase.payments);
    return payment.status === PAYMENT_STATUS_AUTHORIZING;
  }

  isPaymentAuthorized() {
    const { purchase } = this.props;
    const payment = purchase.currentPayment || last(purchase.payments);
    return payment.status === PAYMENT_STATUS_AUTHORIZED;
  }

  isPaymentExpired() {
    const { currentPayment } = this.props.purchase;
    if (!currentPayment || !currentPayment.dueDeadline) return false;
    return new Date(currentPayment.dueDeadline) < new Date();
  }

  renderAuthorizingMessage() {
    const { merchant: { displayName }, purchase: { payments } } = this.props;

    if (Purchase.isMultiPayment(payments)) {
      const payment = findLast(payments, (payment) => {
        return payment.status === PAYMENT_STATUS_AUTHORIZED || payment.PAYMENT_STATUS_AUTHORIZING;
      });

      if (!payment) return;

      return (
        <InfoMessage>
          <FormattedMessage
            id="purchaseDashboard.autorizingPayment.message"
            defaultMessage="Payment {x} of {n} processing -
              waiting for {merchant} to confirm your purchase."
            values={{x: payment.number, n: payments.length, merchant: displayName }}
          />
        </InfoMessage>
      );
    }

    return (
      <InfoMessage>
        <FormattedMessage
          id="purchaseDashboard.paymentProcessing.waitingConfirmation"
          defaultMessage="Payment processing - waiting for {displayName} to confirm your purchase."
          values={{ displayName }}
        />
      </InfoMessage>
    );
  }

  renderCanceledMessage() {
    return (
      <InfoMessage>
        <strong>
          <FormattedMessage
            id="purchaseDashboard.canceledMessage.groupWasCanceled"
            defaultMessage="This group was canceled"
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.canceledMessage.cantMakePurchase"
          defaultMessage="so the purchase can no longer be made."
        />
      </InfoMessage>
    );
  }

  renderCapturedMessage() {
    const { merchant: { displayName }, purchase: { payments } } = this.props;

    const captured = findLast(payments, (payment) => {
      return payment.status === PAYMENT_STATUS_COMPLETED || payment.status === PAYMENT_STATUS_PROCESSING;
    });

    return (
      <InfoMessage>
        <FormattedMessage
          id="purchaseDashboard.capturedMessage.message"
          defaultMessage="{x} of {n} payments have been paid to {displayName}."
          values={{ x: captured.number, n: payments.length, displayName }}
        />
      </InfoMessage>
    );
  }

  renderExpiredMessage() {
    return (
      <InfoMessage>
        <strong>
          <FormattedMessage
            id="purchaseDashboard.expiredMessage.expired"
            defaultMessage="The group deadline expired"
          />
        </strong>
        {' '}
        <FormattedMessage
          id="purchaseDashboard.expiredMessage.contactOrganizer"
          defaultMessage="contact group's organizer for more info."
        />
      </InfoMessage>
    );
  }

  renderIssuesMessage() {
    return (
      <InfoMessage>
        <FormattedMessage
          id="purchaseDashboard.issuesMessage"
          defaultMessage="Some of the groups contributors charges failed"
        />
      </InfoMessage>
    );
  }

  renderMerchantInfo() {
    const { merchant } = this.props;

    return (
      <div className="container mt-5">
        <div className="container">
          <Title
            text={
              <FormattedMessage
                id="purchaseDashboard.merchantInfo.contact"
                defaultMessage="Contact {displayName}"
                values={{ displayName: merchant.displayName }}
              />
            }
            bigger
          />
          <p><span>{merchant.name}</span></p>
          <p><span>{merchant.supportEmail}</span></p>
          <p><span>{merchant.supportPhone}</span></p>
        </div>
      </div>
    );
  }

  renderPaidOutMessage() {
    const { organizerUser: { fullName }, purchase: { confirmationUrl } } = this.props;

    if (this.props.isOrganizer && confirmationUrl) {
      return (
        <InfoMessage>
          <FormattedMessage
            id="purchaseDashboard.orderConfirmation"
            defaultMessage="This group has completed and the purchase has been made – {confirmationUrl}"
            values={{
              confirmationUrl: (
                <a href={confirmationUrl} target="_blank">
                  <b>
                    <FormattedMessage
                        id="purchaseDashboard.viewConfirmation"
                        defaultMessage="view Order Confirmation"
                      />
                  </b>
                </a>
              )
            }}
          />
        </InfoMessage>
      );
    }

    return (
      <InfoMessage>
        <FormattedMessage
          id="purchaseDashboard.paidOutMessage"
          defaultMessage="This group has completed and the purchase has been made
            – big shout out to {fullName}"
            values={{ fullName }}
        />
      </InfoMessage>
    );
  }

  renderPurchaseStatus() {
    const { purchase } = this.props;

    if (this.hasPaymentStatuses([PAYMENT_STATUS_AUTHORIZING, PAYMENT_STATUS_AUTHORIZED])) {
      return this.renderAuthorizingMessage();
    }

    if (this.hasMembershipsIssues()) return this.renderIssuesMessage();
    if (Purchase.isCompleted(purchase)) return this.renderPaidOutMessage();
    if (Purchase.isCanceled(purchase.status)) return this.renderCanceledMessage();

    if (this.hasPaymentStatuses([PAYMENT_STATUS_COMPLETED, PAYMENT_STATUS_PROCESSING])) {
      return this.renderCapturedMessage();
    }

    if (this.isPaymentExpired()) return this.renderExpiredMessage();

    return null;
  }

  renderTermsAndConditions() {
    return (
      <div className="container mt-5">
        <div className="container">
          <DashboardTermsAndConditions
            merchantName={this.props.merchant.displayName}
            slug={this.props.purchase.slug}
            legalDocuments={this.props.legalDocuments}
          />
        </div>
      </div>
    );
  }

  renderShortAndFailedContributors() {
    if (!this.props.isOrganizer) return null;

    const { purchase } = this.props;
    const { payments } = purchase;

    return (
      <div>
        <ShortContributors
          onSolveIssues={this.onSolveIssues}
          onRemoveMember={this.onRemoveMember}
          memberships={this.props.shortMemberships}
          payments={payments}
          asOrganizer={this.props.isOrganizer}
          disable={this.props.disable}
        />
        <FailedContributors
          onSolveIssues={this.onSolveIssues}
          onRemoveMember={this.onRemoveMember}
          memberships={this.props.failedMemberships}
          payments={payments}
          asOrganizer={this.props.isOrganizer}
          disable={this.props.disable}
        />
      </div>
    );
  }

  render() {
    const { purchase } = this.props;

    const { payments } = purchase;
    const { currentPayment } = purchase;
    const renderOrgActions = currentPayment && Purchase.isActive(purchase.status) &&
      Payment.isActive(currentPayment.status);

    return (
      <div className="main-container rounded pb-3">
        {this.renderPurchaseStatus()}
        <div className="container">
          <PurchaseInfo
            purchase={this.props.purchase}
            organizerUser={this.props.organizerUser}
          />
        </div>
        <DetailsNavbar
          onChange={this.onScrollTo}
          isOrganizer={this.props.isOrganizer}
          hasHoldouts={this.props.holdoutMemberships.length > 0}
          hasIssues={this.props.hasIssues}
        />
        {this.renderShortAndFailedContributors()}
        <Contributors
          onInvitePeople={this.onInvitePeople}
          onCantInvitePeople={this.onCantInvitePeople}
          onRemoveMember={this.onRemoveMember}
          memberships={this.props.committedMemberships}
          payments={payments}
          asOrganizer={this.props.isOrganizer}
          userLoggedIn={this.props.userLoggedIn}
          disable={this.props.disable}
          renderOrgActions={renderOrgActions}
        />
        <HoldoutContributors
          onRemoveMember={this.onRemoveMember}
          memberships={this.props.holdoutMemberships}
          payments={payments}
          asOrganizer={this.props.isOrganizer}
          disable={this.props.disable}
        />
        <PurchaseDetails />
        <About />
        {this.renderTermsAndConditions()}
        {this.renderMerchantInfo()}
        <Activities
          purchase={purchase}
          memberships={this.props.memberships}
          organizerUser={this.props.organizerUser}
          onPostComment={this.onPostComment}
          currentUser={this.props.currentUser}
          users={this.props.users}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const user = getCurrentUser(state);
  const purchase = getCurrentPurchase(state);
  const organizerMembership = getOrganizerMembership(state);
  const currentUserMembership = getCurrentUserMembership(state);

  const isOrganizer = currentUserMembership && Membership.isOrganizer(currentUserMembership.role);
  const projectedMemberships = get(state.projections, `shared.memberships`, {});
  const committedMemberships = getCommittedMemberships(state);
  const projectedCommittedMemberships = Membership.mergeWithProjection(committedMemberships, projectedMemberships);
  const users = Object.keys(state.users.byId).map(id => state.users.byId[id]);

  return {
    authentication: state.session.authentication,
    purchase,
    merchant: purchase.merchant,
    legalDocuments: purchase.product.legalDocuments,
    organizerUser: organizerMembership.user,
    isOrganizer,
    hasIssues: false,
    userLoggedIn: !!user,
    failedMemberships: getFailedMemberships(state),
    shortMemberships: getShortMemberships(state),
    committedMemberships: projectedCommittedMemberships,
    holdoutMemberships: getHoldoutMemberships(state),
    disable: Purchase.isCanceled(purchase.status),
    memberships: getMemberships(state),
    currentUser: user,
    users,
  };
};

const mapDispatchToProps = {
  showAlert,
  showInviteModal,
  showRemoveModal,
  showResolveIssuesModal,
  postPurchaseComment,
  fetchPurchaseActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBody);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/dashboard-body.container.js